import subscriptionApi from '../api/subscription'
import {
  SUBSCRIPTION_SUCCESS,
  SUBSCRIPTION_FAILURE,
  SET_SUBSCRIPTION,
} from './types'

function convertSnakeToCamelCase(input) {
  return input
    .split('_')
    .map((word, index) => {
      return index === 0 ? word : word.charAt(0).toUpperCase() + word.slice(1)
    })
    .join('')
}

export default {
  namespaced: true,
  state: {
    error: false,
    msgError: null,
    subscription: null,
  },
  actions: {
    getSubscription({ commit }) {
      return subscriptionApi
        .getSubscription()
        .then(({ data }) => {
          const subscription = {}
          for (const key in data[0]) {
            subscription[convertSnakeToCamelCase(key)] =
              data[0][key] === null ? '' : data[0][key]
          }
          commit(SET_SUBSCRIPTION, subscription)
        })
        .catch(function (error) {
          console.log(error)
          commit(SUBSCRIPTION_FAILURE, error.response.data)
        })
    },
  },
  mutations: {
    [SET_SUBSCRIPTION](state, data) {
      state.subscription = data
    },
    [SUBSCRIPTION_SUCCESS](state) {
      state.error = false
      state.msgError = null
    },
    [SUBSCRIPTION_FAILURE](state, error) {
      state.error = true
      state.msgError = error
    },
  },
  getters: {
    subscription: (state) => state.subscription,
  },
}
